import { Button, type ButtonProps, cn } from '@seen/ui'
import { IconDots } from '@tabler/icons-react'
import type { JSX, ReactNode } from 'react'
import { DropdownMenu } from '#src/components/core/dropdown-menu/DropdownMenu.tsx'
import { DropdownMenuContent } from '#src/components/core/dropdown-menu/DropdownMenuContent.tsx'
import { DropdownMenuTrigger } from '#src/components/core/dropdown-menu/DropdownMenuTrigger.tsx'

export interface MoreDropdownMenuProps {
  children: ReactNode
  className?: string
  // https://github.com/shadcn-ui/ui/issues/1859
  // https://github.com/shadcn-ui/ui/issues/1859#issuecomment-2423190031
  modal?: boolean
  open?: boolean
  onOpenChange?: (open: boolean) => void
  // Drop the menu as soon as it closes. Requires a controlled `open`. The exit
  // animation can be cancelled by a print dialog or a modal opened from an
  // item, which leaves the menu stuck on screen.
  unmountOnClose?: boolean
  size?: ButtonProps['size']
}

export function MoreDropdownMenu({
  children,
  className,
  modal = true,
  open,
  onOpenChange,
  unmountOnClose = false,
  size = 'icon',
}: MoreDropdownMenuProps): JSX.Element {
  return (
    <DropdownMenu modal={modal} open={open} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size={size}
          aria-label="More actions"
          className={cn('-my-2.75 py-2.75', className)}
        >
          <IconDots className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      {unmountOnClose && open === false ? null : (
        <DropdownMenuContent align="end">{children}</DropdownMenuContent>
      )}
    </DropdownMenu>
  )
}
